import { render, staticRenderFns } from "./InformationObligationViewModal.vue?vue&type=template&id=34fa1ed6&"
import script from "./InformationObligationViewModal.vue?vue&type=script&lang=js&"
export * from "./InformationObligationViewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports